import { authJsonHeaders, getAccessToken } from "@/integrations/cloud/authService";
import { requestCloudApi } from "@/integrations/cloud/cloudApiClient";
import { isCloudConfigured } from "@/integrations/cloud/cloudConfig";

export type StorePlatform = "APPLE_APP_STORE" | "GOOGLE_PLAY_STORE";

export type StorePurchaseVerificationInput = {
  platform: StorePlatform;
  productId: string;
  transactionId?: string;
  purchaseToken?: string;
  packageName?: string;
};

export type StoreRestoreResult = {
  restored: boolean;
  verifiedCount: number;
  issues: Array<{ index: number; message: string; code?: string }>;
};

export const isEntitlementApiConfigured = isCloudConfigured;

export const verifyStorePurchase = async (
  input: StorePurchaseVerificationInput
): Promise<void> => {
  const token = await getAccessToken();
  if (!token) {
    throw new Error("Sign in before syncing your subscription.");
  }

  await requestCloudApi("/verify-purchase", {
    method: "POST",
    headers: await authJsonHeaders(),
    body: JSON.stringify(input)
  });
};

export const restoreStorePurchases = async (
  purchases: StorePurchaseVerificationInput[]
): Promise<StoreRestoreResult> => {
  const token = await getAccessToken();
  if (!token) {
    throw new Error("Sign in before restoring purchases.");
  }

  return requestCloudApi<StoreRestoreResult>("/restore-purchases", {
    method: "POST",
    headers: await authJsonHeaders(),
    body: JSON.stringify({ purchases })
  });
};
